import { useSelector } from "react-redux";

export const useUserStore = (selector) => {
  const state = useSelector((reduxState) => ({
    loggedIn: reduxState.user.loggedIn,
    userDetails: reduxState.user.userDetails,
  }));

  return selector ? selector(state) : state;
};
